;(() => {
    window.addEventListener('load', (loadEvent) => {
        loadEvent.preventDefault();
        if ( window.location.hash !== '' ) {
            let target = document.querySelector(window.location.hash);
            window.scroll({top: target.offsetTop, left: 0, behavior: 'smooth'});
        }
    });

    document.addEventListener('click', (clickEvent) => {
        clickEvent.path.forEach((el) => {
            if ( el.nodeName == 'A' && el.getAttribute('href').substring(0, 1) == '#' && el.getAttribute('href').length > 1 ){
                clickEvent.preventDefault();
                let target = document.querySelector(el.getAttribute('href'));
                window.scroll({top: target.offsetTop, left: 0, behavior: 'smooth'});
            }
        });
    });
})()